var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#C32AA3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.44c2.14 0 2.4.01 3.24.05.78.03 1.2.16 1.48.27.38.15.64.32.92.6.28.28.46.55.6.92.1.28.24.7.27 1.48.04.85.05 1.1.05 3.24 0 2.13 0 2.39-.05 3.23-.03.78-.16 1.2-.27 1.48-.14.37-.32.64-.6.92-.28.28-.54.45-.92.6-.28.1-.7.24-1.48.27-.85.04-1.1.05-3.24.05-2.13 0-2.39-.01-3.23-.05a4.39 4.39 0 0 1-1.48-.27 2.48 2.48 0 0 1-.92-.6 2.46 2.46 0 0 1-.6-.92 4.4 4.4 0 0 1-.28-1.48c-.03-.85-.04-1.1-.04-3.23 0-2.14 0-2.4.04-3.24.04-.78.17-1.2.28-1.48.14-.37.32-.64.6-.92.28-.28.54-.45.92-.6.28-.1.7-.24 1.48-.27.84-.04 1.1-.05 3.23-.05ZM12 4c-2.17 0-2.44 0-3.3.05-.84.03-1.43.17-1.94.37a4.03 4.03 0 0 0-2.34 2.34c-.2.5-.34 1.1-.37 1.94C4 9.56 4 9.83 4 12s0 2.45.05 3.3c.03.85.17 1.43.37 1.94a4.03 4.03 0 0 0 2.34 2.34c.51.2 1.1.34 1.94.37.86.04 1.13.05 3.3.05s2.45 0 3.3-.05a5.85 5.85 0 0 0 1.94-.37 3.94 3.94 0 0 0 2.34-2.34c.2-.5.34-1.09.37-1.94.04-.85.05-1.12.05-3.3 0-2.17 0-2.44-.05-3.3a5.84 5.84 0 0 0-.37-1.93 4.04 4.04 0 0 0-2.33-2.35 5.9 5.9 0 0 0-1.94-.37C14.45 4.01 14.18 4 12 4Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.9a4.11 4.11 0 1 0 0 8.22 4.11 4.11 0 0 0 0-8.23Zm0 6.77a2.67 2.67 0 1 1 0-5.34 2.67 2.67 0 0 1 0 5.34Zm5.24-6.94a.96.96 0 1 1-1.92 0 .96.96 0 0 1 1.92 0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/InstagramIcon.4a12d06f80d7aa9b721b6224bff7ec6a.svg";
export { ForwardRef as ReactComponent };